import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketRemoveCoupon',
  props: {
    couponCode: {
        required: false,
        default: null,
        validator: prop => typeof prop === 'string' || prop === null,
        type: String
    }
},
  emits: ["remove"],
  setup(__props, { emit }: { emit: ({(e: 'remove', couponCode: string): void}), expose: any, slots: any, attrs: any }) {




const isBasketLocked = computed<boolean>(() => store.getters['basket/isBasketLocked']);

function removeCoupon(couponCode: string) {
    emit('remove', couponCode);
}

return { __sfc: true,emit, isBasketLocked, removeCoupon }
}

})